document.addEventListener('DOMContentLoaded', function() {
  // Edit these messages to the texts you want to display
  var messages = [
    "Welcome to our store",
    "Free Shipping on orders above £60",
  ];

  var currentIndex = 0;
  var announcementBar = document.getElementById('announcement-message');

  function updateMessage() {
    announcementBar.textContent = messages[currentIndex];
    currentIndex = (currentIndex + 1) % messages.length;
  }

  // Initially set the message
  updateMessage();

  // Change the message every 10 seconds
  setInterval(updateMessage, 5000);
});
